import { defineRule } from 'vee-validate'

const maxLength = () => {
  defineRule<any, any[]>('max_length', (value, [compareValue], _ctx: any) => {
    return value.length <= compareValue
  })
}

export default maxLength
